// The headline starts oversized on the seasonal band, shrinks as the page
// scrolls and lands as the carousel's heading. A scrub, so it also runs back.

((window, document) => {
    const section = document.querySelector('.js--events-statement')

    const headline = section
        && section.querySelector('.events-carousel__headline')

    if (!headline)
        return

    // side margins off the 1440px design: a left-aligned block stops at 93px, a
    // centred line has even air on both sides and may run wider
    const BLEED = 0.0646
    const BLEED_CENTRED = 0.0448

    // where the shrink starts and lands, as fractions of viewport height. START
    // sits low so the copy is already shrinking as it clears the bottom edge
    const START = 0.95
    const END = 0.18

    // narrow screens have no statement to scrub, so how far up the viewport the
    // band has come stands in for the scrub's progress
    const REVEAL_AT = 0.8

    const RUNWAY = 'events-carousel_statement'
    const REVEALED = 'events-carousel_revealed'
    const TIMED = 'events-carousel_timed'

    const reduced = Boolean(window.matchMedia)
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches

    let scale = 1
    let shift = 0
    // the heading's middle, measured down from the top of the band
    let anchor = 0
    let active = false
    let simple = false
    let revealed = false
    let timed = false
    let ticking = false
    let pending = false

    /**
    * Measure the Heading's Line Boxes
    * @return {Object} { width, count, left }
    */
    function lines () {
        const range = document.createRange()

        range.selectNodeContents(headline)

        const rects = range.getClientRects()

        let width = 0
        let left = 0
        let count = 0

        for (let i = 0; i < rects.length; i++) {
            if (!rects[i].width)
                continue

            count++

            if (rects[i].width > width) {
                width = rects[i].width
                left = rects[i].left
            }
        }

        return { width, count, left }
    }

    /**
    * Hand the Header Over, or Take it Back
    * @param  {Boolean} done
    * @return {Void}
    */
    function settle (done) {
        if (done === revealed)
            return

        revealed = done

        if (done)
            section.classList.add(REVEALED)
        else
            section.classList.remove(REVEALED)
    }

    /**
    * Switch the Timing On and Redraw
    * @return {Void}
    */
    function timing () {
        section.classList.add(TIMED)
        render()
    }

    /**
    * Let the Move Animate, a Frame After it Goes Off-stage
    * @return {Void}
    */
    function stage () {
        if (timed)
            return

        timed = true

        // a frame is the accurate cue, but none of them arrive while the tab is
        // hidden, and the band must never be left off-stage for good
        window
            .requestAnimationFrame(timing)

        window
            .setTimeout(timing, 400)
    }

    /**
    * Work Out the Opening State From the Resting One
    * @return {Void}
    */
    function measure () {
        headline.style.transform = ''
        section.classList.remove(RUNWAY)

        active = true
        simple = false

        section.classList.add(RUNWAY)

        // the header goes off-stage on the frame the run-up appears, and only
        // then is it allowed to animate, so the move is never a fade-out on load
        stage()

        const bounds = section.getBoundingClientRect()
        const block = headline.getBoundingClientRect()
        const line = lines()

        // one line is centred on the band and stretches to its edges; more than
        // one has breaks to keep, so the column it wrapped in stretches instead
        const single = line.count === 1
        const from = single
            ? { width: line.width, left: line.left }
            : { width: block.width, left: block.left }

        const available = bounds.width
            * (1 - (single ? BLEED_CENTRED : BLEED) * 2)

        scale = from.width
            ? Math.max(1, available / from.width)
            : 1

        shift = single
            ? bounds.left + bounds.width / 2 - from.left - from.width * scale / 2
            : bounds.left + bounds.width * BLEED - from.left

        anchor = block.top - bounds.top + block.height / 2

        if (scale > 1)
            return

        // a heading already filling the band has nothing to open from, so the
        // reveal rides the band into view on its own instead
        active = false
        simple = true
        settle(false)
    }

    /**
    * Scrub the Statement Against the Scroll Position
    * @return {Void}
    */
    function render () {
        ticking = false

        const viewport = window.innerHeight
            || document.documentElement.clientHeight

        if (simple) {
            // a band already in view on load would snap rather than arrive, so
            // nothing lands until the timing is on
            if (section.classList.contains(TIMED))
                settle(section.getBoundingClientRect().top
                    < (viewport * REVEAL_AT))

            return
        }

        if (!active)
            return

        // where the heading is sitting on screen; it rides the scroll untouched,
        // so this is the page moving, not the copy
        const middle = section.getBoundingClientRect().top + anchor

        const progress = Math.min(1, Math.max(0,
            (START * viewport - middle) / ((START - END) * viewport)))

        settle(progress === 1)

        const opening = 1 - progress

        headline.style.transform = opening
            ? `translateX(${shift * opening}px) scale(${
                1 + (scale - 1) * opening})`
            : ''
    }

    /**
    * Queue a Frame
    * @return {Void}
    */
    function onScroll () {
        if (ticking)
            return

        ticking = true

        window
            .requestAnimationFrame(render)
    }

    /**
    * Re-measure, Then Redraw
    * @return {Void}
    */
    function refresh () {
        measure()
        render()
    }

    /**
    * Queue a Re-measure
    * @return {Void}
    */
    function onResize () {
        if (pending)
            return

        pending = true

        window
            .requestAnimationFrame(() => {
                pending = false
                refresh()
            })
    }

    if (reduced)
        return

    refresh()

    window
        .addEventListener('scroll',
            onScroll)

    window
        .addEventListener('resize',
            onResize)

    // Playfair arrives from a CDN, and the line boxes move when it lands
    window
        .addEventListener('load',
            refresh)

    if (document.fonts && document.fonts.ready
            && typeof document.fonts.ready.then === 'function')
        document.fonts.ready.then(refresh)
})(window, document)
